export default "__VITE_ASSET__BuVscovH__"